<template>
    <div class="card h-100 rounded-0 border-0" :class="animation">
        <div class="card-body text-center h-100">
            <div class="row mb-5">
                <BackButton @click.native="handleBackToStep()" />
            </div>
            <div class="row mb-5">
                <div class="form-wrap-step">
                    <h5 class="title__normal">引き取り作業は必要ですか。</h5>
                </div>
            </div>
            <div class="form-wrap-step">
                <div class="row">
                    <div class="col-md-12 below-adv-btn">
                        <button class="btn btn-yellow-dark px-4 d-inline-block btn-lg mb-3 rounded-1" @click="handleClick(IS_COLLECTED)">
                            <span class="text">はい</span>
                        </button>
                        <button class="btn btn-yellow-dark px-4 d-inline-block btn-lg mb-3 rounded-1" @click="handleClick(NO_COLLECTED)">
                            <span class="text">いいえ</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BackButton from './BackButton.vue';

    export default {
    name: 'LocationCollect',
    props: {
        animation: {
            default: ''
        },
        followStep: {
            default: ''
        },
        allData: {
            default: ''
        }
    },
    data() {
        return {
            IS_COLLECTED: 1,
            NO_COLLECTED: 0,
            data: {},
            FOLLOW_OVERSIZED: 1,
            FOLLOW_APPLIANCE: 2,
        };
    },
    methods: {
        async postData() {
            this.data = {
                ...this.allData,
                is_collect: this.NO_COLLECTED,
            };
            let res = await axios.post(`/api/register/register-info/`, this.data);
            if (res.data.success) {
                window.location.href = '/order/order-oversized-step-company';
            } else {
                alert('Failed to continue');
            }
        },
        handleClick(type) {
            if (this.followStep === this.FOLLOW_OVERSIZED) {
                if (type === this.IS_COLLECTED) {
                    const currentStep = 4;
                    const followStep = 1;
                    this.$emit("handleChangeStep", currentStep, followStep);
                } else {
                    this.postData();
                }
            }
            if (this.followStep === this.FOLLOW_APPLIANCE) {
                if (type === this.IS_COLLECTED) {
                    const currentStep = 3;
                    const followStep = 2;
                    this.$emit("handleChangeStep", currentStep, followStep);
                } else {
                    this.postData();
                }
            } 
        },
        handleBackToStep() {
            if (this.followStep === 1) {
                const currentStep = 2;
                const followStep = 1;
                this.$emit("handleChangeStep", currentStep, followStep);
            }
            if (this.followStep === 2) {
                const currentStep = 1;
                const followStep = 2;
                this.$emit("handleChangeStep", currentStep, followStep);
            }  
        },
    },
    components: { 
        BackButton 
    }
}
</script>